import 'select2/dist/js/select2.full.min';
import set_table_items_height from "../set-table-items-height";

const information_tab_table = () => {
    if ($('.information-tab-table-module').length) {
        $('.information-table-tabs .table-tab').on('click', function(){
            let $this = $(this);
            let tableIndex = $this.data('table-index');
            let $module = $this.parent().parent().parent();
            let $table = $('.dual-column-table-wrapper[data-table-index="' + tableIndex + '"] .dual-column-table' , $module);

            $this.parent().find('.table-tab').removeClass('active');
            $this.addClass('active');
            $('.dual-column-table-wrapper', $module).removeClass('active');
            $('.dual-column-table-wrapper[data-table-index="' + tableIndex + '"]', $module).addClass('active');

            set_table_items_height($table);
        });

        $('.information-table-tabs .tab-select').select2({
            selectionCssClass: 'info-table-select',
            dropdownCssClass: 'info-table-dropdown',
            width: '100%'
        });

        $('.information-table-tabs .tab-select').on('change', function() {
            let $this = $(this);
            let tableIndex = $this.val();
            let $module = $this.parent().parent();
            let $table = $('.dual-column-table-wrapper[data-table-index="' + tableIndex + '"] .dual-column-table' , $module);

            $('.dual-column-table-wrapper', $module).removeClass('active');
            $('.dual-column-table-wrapper[data-table-index="' + tableIndex + '"]', $module).addClass('active');
            $table.slick('refresh');

            set_table_items_height($table);
        });
    }
}

export default information_tab_table;